export interface AppConfig {
  id: string;
  name: string;
  tagline?: string;
  description?: string;
  packageName: string;
  appleAppId?: string;
  appleAppIdFull?: string;
  scheme?: string;
  icon?: string;
  accentColor?: string;
  storeLinks: {
    apple?: string;
    google: string;
  };
  hasInvite?: boolean;
}

export const apps: AppConfig[] = [
  {
    id: 'bye-for-now',
    name: 'Bye For Now',
    icon: '/app-icons/bye-for-now.png',
    tagline: 'Stay in touch with friends',
    description: 'Simplify the way to keep in touch with your closest friends. Recommends who to reach out to based on when you last connected.',
    packageName: 'org.monogatari.project',
    appleAppId: '6502987623',
    appleAppIdFull: 'G53V6GR8JQ.org.monogatari.project',
    scheme: 'monogatari',
    accentColor: '#F87089',
    storeLinks: {
      apple: 'https://apps.apple.com/us/app/bye-for-now/id6502987623',
      google: 'https://play.google.com/store/apps/details?id=org.monogatari.project',
    },
    hasInvite: true,
  },
  {
    id: 'perfectpitch',
    name: 'PerfectPitch',
    icon: '/app-icons/perfectpitch.png',
    tagline: 'Train tonality',
    description: 'Develop your musical ear through practice on real instruments. Note and interval training, chord recognition, piano or guitar input.',
    packageName: 'com.perfectpitch',
    accentColor: '#7B68EE',
    storeLinks: {
      apple: 'https://apps.apple.com/us/app/perfectpitch-train-tonality/id6759777515',
      google: 'https://play.google.com/store/apps/details?id=com.perfectpitch',
    },
  },
  {
    id: 'readfast',
    name: 'ReadFast',
    icon: '/app-icons/readfast.png',
    tagline: 'Speed read anything',
    description: 'Read faster with RSVP (Rapid Serial Visual Presentation). Flash words at adjustable speeds to improve your reading pace.',
    packageName: 'com.monogatari.readfast',
    accentColor: '#20B2AA',
    storeLinks: {
      apple: 'https://apps.apple.com/us/app/readfast-speed-read-anything/id6756295327',
      google: 'https://play.google.com/store/apps/details?id=com.monogatari.readfast',
    },
  },
  {
    id: 'progressbar',
    name: 'ProgressBar',
    icon: '/app-icons/progressbar.png',
    tagline: 'Tracker for goals',
    description: 'A no-nonsense self tracker for your goals. Track habits and progress with a clean, focused interface.',
    packageName: 'com.progressbar',
    accentColor: '#FF8C42',
    storeLinks: {
      apple: 'https://apps.apple.com/us/app/progressbar-tracker-for-goals/id6754582543',
      google: 'https://play.google.com/store/apps/details?id=com.progressbar',
    },
  },
  {
    id: 'fpseyetrainer',
    name: 'FPSEyeTrainer',
    icon: '/app-icons/fpseyetrainer.png',
    tagline: 'Warmup for FPS',
    description: 'Visual reflex training for FPS. Exercises for tracking, focus, and reaction time.',
    packageName: 'com.fpseyetrainer',
    accentColor: '#4A90D9',
    storeLinks: {
      apple: 'https://apps.apple.com/us/app/fpseyetrainer-warmup-for-fps/id6759312335',
      google: 'https://play.google.com/store/apps/details?id=com.fpseyetrainer',
    },
  },
];
